import axios from "axios";

export const DoorayMessageApi = {
    Type: {
        RETURN_EXCHANGE: {
            botName: "피아르 반품/교환 마스터 봇",
            botIconImage:
                "https://s3.ap-northeast-2.amazonaws.com/test.piaar.co.kr/Louis.png",
            serviceUrl:
                "https://piaar.dooray.com/services/3206627054248384796/4295115143812376178/YU7EAP-CQWuQP6xFt36ymQ",
        },
    },
    sendMessage: async ({ botType, message }) => {
        const { botName, botIconImage, serviceUrl } =
            DoorayMessageApi.Type[botType];
        await axios.post(serviceUrl, {
            botName,
            botIconImage: botIconImage,
            text: message,
        });
    },
};
